module.exports = function isFunction (fn) {
  return Object.prototype.toString.call(fn) === '[object Function]'
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-function/index.js
// module id = 329
// module chunks = 96961042003272 139266963665775